import { jsx, jsxs } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { RuiIconChevronLeft, RuiIconChevronRight } from "@/lib/icons";
import { RuiButton } from "../button";
import { PAGINATION_DEFAULT_LABEL, clampPage } from "./pagination.script";
import "./pagination.script";
function getPageItems(page, pageCount, siblingCount) {
  const visibleCount = siblingCount * 2 + 5;
  if (pageCount <= visibleCount) {
    return Array.from({
      length: pageCount
    }, (_, index) => index + 1);
  }
  const start = Math.max(2, page - siblingCount);
  const end = Math.min(pageCount - 1, page + siblingCount);
  const items = [1];
  if (start > 2) items.push("start-ellipsis");
  for (let current = start; current <= end; current += 1) items.push(current);
  if (end < pageCount - 1) items.push("end-ellipsis");
  items.push(pageCount);
  return items;
}
export function RuiPaginationNav({
  label,
  page,
  pageCount,
  disabled = false,
  siblingCount = 1
}) {
  const resolvedPageCount = Math.max(1, Math.floor(pageCount) || 1);
  const resolvedPage = clampPage(page, resolvedPageCount);
  const resolvedSiblingCount = Math.max(0, Math.floor(siblingCount) || 0);
  const items = getPageItems(resolvedPage, resolvedPageCount, resolvedSiblingCount);
  return /* @__PURE__ */jsx("nav", {
    class: "rui-pagination__nav",
    "aria-label": label,
    children: /* @__PURE__ */jsxs("ul", {
      class: "rui-pagination__list",
      children: [/* @__PURE__ */jsx("li", {
        children: /* @__PURE__ */jsxs(RuiButton, {
          variant: "ghost",
          size: "sm",
          class: "rui-pagination__link rui-pagination__link--previous",
          "data-pagination-page": resolvedPage - 1,
          "aria-label": "Go to previous page",
          disabled: disabled || resolvedPage <= 1,
          children: [/* @__PURE__ */jsx(RuiIconChevronLeft, {}), /* @__PURE__ */jsx("span", {
            children: "Previous"
          })]
        })
      }), items.map(item => typeof item === "number" ? /* @__PURE__ */jsx("li", {
        class: cx("rui-pagination__page", item === resolvedPage && "rui-pagination__page--current"),
        children: /* @__PURE__ */jsx(RuiButton, {
          variant: item === resolvedPage ? "filled" : "ghost",
          size: "sm",
          square: true,
          class: "rui-pagination__link",
          "data-pagination-page": item,
          "aria-label": `Go to page ${item}`,
          "aria-current": item === resolvedPage ? "page" : void 0,
          disabled,
          children: item
        })
      }, item) : /* @__PURE__ */jsx("li", {
        class: "rui-pagination__ellipsis",
        "aria-hidden": "true",
        children: "\u2026"
      }, item)), /* @__PURE__ */jsxs("li", {
        class: "rui-pagination__status",
        children: [resolvedPage, " / ", resolvedPageCount]
      }), /* @__PURE__ */jsx("li", {
        children: /* @__PURE__ */jsxs(RuiButton, {
          variant: "ghost",
          size: "sm",
          class: "rui-pagination__link rui-pagination__link--next",
          "data-pagination-page": resolvedPage + 1,
          "aria-label": "Go to next page",
          disabled: disabled || resolvedPage >= resolvedPageCount,
          children: [/* @__PURE__ */jsx("span", {
            children: "Next"
          }), /* @__PURE__ */jsx(RuiIconChevronRight, {})]
        })
      })]
    })
  });
}
export function RuiPagination({
  children,
  label = PAGINATION_DEFAULT_LABEL,
  page = 1,
  pageCount = 1,
  disabled = false,
  siblingCount = 1,
  class: className,
  ...props
}) {
  const resolvedPageCount = Math.max(1, Math.floor(pageCount) || 1);
  const resolvedPage = clampPage(page, resolvedPageCount);
  const resolvedSiblingCount = Math.max(0, Math.floor(siblingCount) || 0);
  return /* @__PURE__ */jsx("rui-pagination", {
    ...props,
    class: cx("rui-pagination", className),
    label,
    page: resolvedPage,
    pageCount: resolvedPageCount,
    disabled,
    siblingCount: resolvedSiblingCount,
    children: children ?? /* @__PURE__ */jsx(RuiPaginationNav, {
      label,
      page: resolvedPage,
      pageCount: resolvedPageCount,
      disabled,
      siblingCount: resolvedSiblingCount
    })
  });
}